export default "__VITE_ASSET__DUiAIFMS__"